/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceUtilizationResponse {
    getFixupPrototypeFunction() { return InventoryResourceUtilizationResponse.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceUtilizationResponse>): InventoryResourceUtilizationResponse {
        let obj = Object.assign(new InventoryResourceUtilizationResponse(), model);
        InventoryResourceUtilizationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceUtilizationResponse>): InventoryResourceUtilizationResponse {
        if (!model) return null;
        return InventoryResourceUtilizationResponse.newInstance(<InventoryResourceUtilizationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceUtilizationResponse) {
        if (!obj) return;

        models.InventoryResourceUtilizationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceUtilizationResponse): boolean {
        Object.setPrototypeOf(obj, InventoryResourceUtilizationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.series) {
            for (let val of this.series) {
                models.InventoryResourceUtilizationSeries.fixupPrototype(val);
            }
        }
        if (this.timestamps) {
            for (let i = 0; i < this.timestamps.length; i++) {
                let val = this.timestamps[i];
                if (typeof val === "string") {
                    this.timestamps[i] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * Start of every hour in the window, shared by all series. Every statistic array has one entry per timestamp
     */
    timestamps: Array<Date>;

    /**
     * One entry per metric, in alphabetical order. Empty when nothing is stored for the window
     */
    series: Array<models.InventoryResourceUtilizationSeries>;

}
